import React from 'react';
import { DialogUI } from '../Interface';
import { Grid, Box, Typography } from '@mui/material';
import { sxConfig } from './workSheetCreator.style';

const WorkAreaDialog = ({ open, handleClose, workAreas, setValues }) => {
  const handleClick = (workAreaId) => {
    setValues((prev) => ({
      ...prev,
      serviceTask: prev.serviceTask.map((task) => ({
        ...task,
        workAreaId,
      })),
    }));
    handleClose();
  };

  return (
    <DialogUI open={open} onClose={handleClose} headerContent="Munkaállomások" fullWidth={true} maxWidth="sm">
      <Grid container spacing={1} columnSpacing={0.2} pt={2}>
        {workAreas.length > 0 &&
          workAreas.map((workArea) => (
            <Grid item xs={6} p={2} key={workArea.id}>
              <Box sx={sxConfig.buttonDialogBox} onClick={() => handleClick(workArea.id)}>
                <Typography sx={sxConfig.buttonDialogTypography1}>{workArea.code}</Typography>
                <Typography sx={sxConfig.buttonDialogTypography2}>{workArea.name}</Typography>
              </Box>
            </Grid>
          ))}
      </Grid>
    </DialogUI>
  );
};

export default WorkAreaDialog;
